import script from "./ClearQueriesButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClearQueriesButton.vue?vue&type=script&setup=true&lang=ts"

import "./ClearQueriesButton.vue?vue&type=style&index=0&id=7585affa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7585affa"]])

export default __exports__